import { ParallaxContainer } from './parallax-container.class';

export class ParallaxContent {
    private parallaxSelector: string = '.parallax-container';
    private $containers: JQuery;
    private parallaxContainers: ParallaxContainer[] = [];

    public init() {
        this.$containers = $(this.parallaxSelector).not('.parallax-container--initialized');

        if (this.$containers.length > 0) {
            this.$containers.each((index, element) => {
                const parallaxContainer = new ParallaxContainer(element, { key: index });
                parallaxContainer.init();
                this.parallaxContainers.push(parallaxContainer);
            });

            $(window).on('scroll', () => {
                for (const parallaxContainer of this.parallaxContainers) {
                    parallaxContainer.checkEffect();
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/parallax-content/parallax-content.class.ts